import { render, staticRenderFns } from "./DlgResetPassword.vue?vue&type=template&id=d021a5fa&scoped=true"
import script from "./DlgResetPassword.vue?vue&type=script&lang=js"
export * from "./DlgResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d021a5fa",
  null
  
)

export default component.exports